<template>
  <option-base :model-value="modelValue" :selected="selected" :option="option">
    <template #prefix>
      <lf-avatar :username="option" :size="16" />
    </template>
  </option-base>
</template>
<script setup lang="ts">
import OptionBase from "@/components/communicationLogs/filters/OptionBase.vue";
import LfAvatar from "@/components/ui/LFAvatar.vue";

interface Props {
  modelValue: string;
  selected?: string[];
  option: string;
}
defineProps<Props>();
</script>
